export const releaseCheckLabels: Record<string, string> = {
  binding: "Project and original run", metadata: "Release metadata", date: "Target date",
  credits: "Contributor credits", splits: "Proposed splits", audio: "Audio reference",
  artwork: "Artwork reference", rights: "Rights", disclosure: "Artificial intelligence disclosure",
  actions: "Action proof", downstream: "Syntha handoff draft"
};
export const releaseCheckStatuses: Record<string, string> = {
  passed_structure: "Required information supplied", missing: "Information missing", invalid: "Needs correction",
  reference_supplied: "Reference supplied", review_required: "Review needed"
};
